import { PapiDeviation } from '@wix/da-papi-types';
import { usePushModal } from '../../utils/hooks/usePushModal';
import useDeviationStats from '../useDeviationStats';
import { useIsCurrentUserDeviationAuthor } from '../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useCallback } from 'react';
import useDeviationGroupListPopup from '../../DeviationGroupListPopup/useDeviationGroupListPopup';
import { ModalType } from '../../Modals/redux/types';

export default function useOpenGroupStatModal(
  deviation: PapiDeviation
): () => void {
  const { groups } = useDeviationStats(deviation);
  const currentUserDeviationAuthor = useIsCurrentUserDeviationAuthor(deviation);
  const openAddToGroupPopup = usePushModal(ModalType.ADD_TO_GROUP);
  const openAddToGroupPopupWithParams = useCallback(() => {
    openAddToGroupPopup({
      actionBarType: 'primary',
      deviation,
    });
  }, [openAddToGroupPopup, deviation]);
  const openDeviationGroupListPopup = useDeviationGroupListPopup(deviation);

  return groups <= 0 && currentUserDeviationAuthor
    ? openAddToGroupPopupWithParams
    : openDeviationGroupListPopup;
}
